import React, { useEffect } from "react"

import classNames from "@utils/classnames"

import * as styles from "./nav.module.scss"
import Clickable from "../clickable"
import classnames from "@utils/classnames"

const Nav = ({ logo, showWhenRef, buttonProps, extraRight }) => {
  useEffect(() => {
    const scrollEvent = () => {
      if (!(showWhenRef && showWhenRef.current)) {
        return
      }
      const { top } = showWhenRef.current.getBoundingClientRect()
      document.getElementById("nav").style.opacity = top <= 56 ? "1" : "0"
    }
    window.addEventListener("scroll", scrollEvent)

    return () => {
      window.removeEventListener("scroll", scrollEvent)
    }
  }, [showWhenRef])
  return (
    <nav id="nav" className={classNames(styles.nav)}>
      <div>
        <img src={logo} alt="logo" className={styles.logo} />
        <div className={styles.right}>
          {buttonProps && (
            <Clickable
              {...buttonProps}
              className={classnames(styles.joinBtn, buttonProps.className)}
            />
          )}
          {extraRight}
        </div>
      </div>
    </nav>
  )
}

export default Nav
